module.exports = __webpack_public_path__ + "img/3.730ae614.jpg";